import { render, staticRenderFns } from "./mayiba_dingdan.vue?vue&type=template&id=34a427f6&"
import script from "./mayiba_dingdan.vue?vue&type=script&lang=js&"
export * from "./mayiba_dingdan.vue?vue&type=script&lang=js&"
import style0 from "./mayiba_dingdan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports